import { useEffect } from 'react';

const WatermarkRemover = () => {
  useEffect(() => {
    // Function to remove watermark elements
    const removeWatermark = () => {
      // Only target elements that are likely to be watermarks
      // Avoid touching EASY POWER logo
      
      // Remove elements with specific watermark characteristics
      const watermarkSelectors = [
        'a[href*="emergent.sh"]',
        'a[href*="emergent.ai"]',
        'a[href*="emergentagent.com"]',
        'img[alt*="Made with"]',
        'img[alt*="Powered by"]',
        'div[title*="Made with"]',
        'span[title*="Made with"]'
      ];

      watermarkSelectors.forEach(selector => {
        try {
          document.querySelectorAll(selector).forEach(el => {
            // Double check it's not the EASY POWER logo
            if (!el.src?.includes('easy_power_logo') && 
                !el.alt?.includes('EASY POWER') &&
                !el.closest('header')) {
              el.style.display = 'none';
              el.remove();
            }
          });
        } catch (e) {
          // Silent fail
        }
      });

      // Remove text nodes containing watermark text (but not EASY POWER)
      const walker = document.createTreeWalker(
        document.body,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      const watermarkTexts = [
        'made with emergent',
        'powered by emergent',
        'emergent.sh',
        'emergent.ai'
      ];

      const textNodes = [];
      let node;
      while ((node = walker.nextNode())) {
        const text = node.textContent.toLowerCase().trim();
        if (watermarkTexts.some(watermark => text.includes(watermark)) &&
            !text.includes('easy power') &&
            !text.includes('easy-power')) {
          textNodes.push(node);
        }
      }

      textNodes.forEach(textNode => {
        const parent = textNode.parentElement;
        if (parent && !parent.closest('header') && !parent.closest('nav')) {
          parent.style.display = 'none';
          parent.remove();
        }
      });

      // Remove positioned elements that look like watermarks (bottom corner)
      const positionedElements = document.querySelectorAll(
        '[style*="position: fixed"], [style*="position: absolute"]'
      );
      
      positionedElements.forEach(el => {
        const style = window.getComputedStyle(el);
        const isBottomRight = (style.bottom && parseInt(style.bottom) < 50) &&
                             (style.right && parseInt(style.right) < 50);
        
        if (isBottomRight && 
            !el.closest('header') && 
            !el.querySelector('img[alt*="EASY POWER"]') &&
            el.textContent.toLowerCase().includes('emergent')) {
          el.remove();
        }
      });
    };

    // Run after a small delay to let the page load
    const timeoutId = setTimeout(removeWatermark, 500);

    // Run on DOM changes but with throttling
    let timeoutHandle;
    const observer = new MutationObserver(() => {
      clearTimeout(timeoutHandle);
      timeoutHandle = setTimeout(removeWatermark, 200);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(timeoutHandle);
      observer.disconnect();
    };
  }, []);

  return null;
};

export default WatermarkRemover;